const badgeTextMap = {
  undefined: 'En attente',
  low: 'Faible',
  medium: 'Standard',
  high: 'Élevé',
  rejected: 'Refus',
  blacklisted: 'Liste noire'
};

const badgeColorMap = {
  undefined: 'text-gray-600',
  low: 'text-green-700',
  medium: 'text-amber-700',
  high: 'text-red-700',
  rejected: 'text-white bg-black',
  blacklisted: 'text-white bg-black'
};

const baseClass = 'font-bold whitespace-nowrap min-w-[5rem]';

export function useRiskBadges() {
  const badgeTextFor = (level) => badgeTextMap[level] || badgeTextMap.undefined;
  const badgeClassFor = (level) => `${baseClass} ${badgeColorMap[level] || badgeColorMap.undefined}`;

  return {
    badgeTextFor,
    badgeClassFor,
  };
}
